import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbItemProps,
  BreadcrumbLink,
  BreadcrumbLinkProps,
} from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { ChevronRightIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';

export type BreadcrumbsItem = {
  label: string;
  href?: string;
};

export type BreadcrumbsProps = {
  items: BreadcrumbsItem[];
};

const sharedLinkProps: Partial<BreadcrumbLinkProps> = {
  color: 'supportBlue.100',
  fontSize: 'sm',
  fontWeight: '600 !important',
  textDecoration: 'none',
  _hover: {
    color: 'supportBlue.100',
  },
  _visited: {
    color: 'supportBlue.100',
  },
  flexShrink: 1,
};

const sharedItemProps: Partial<BreadcrumbItemProps> = {
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  if (items.length === 0) return null;

  const lastIndex = items.length - 1;

  return (
    <Box bgColor='supportBlue.10' py={2}>
      <ContentContainer>
        <Breadcrumb
          listProps={{ gap: '4px' }}
          position='relative'
          separator={<ChevronRightIcon color='#175CFF' h='24px' w='24px' />}
          spacing={1}
          zIndex={2}
        >
          {items.map((item, index) => {
            const isCurrentPage = index === lastIndex;

            if (isCurrentPage) {
              return (
                <BreadcrumbItem key={item.label} {...sharedItemProps} isCurrentPage>
                  <BreadcrumbLink
                    color='supportGray.70 !important'
                    fontSize='sm'
                    fontWeight='400'
                    noOfLines={1}
                    textDecoration='none'
                    wordBreak='break-all'
                  >
                    {item.label}
                  </BreadcrumbLink>
                </BreadcrumbItem>
              );
            }

            return (
              <BreadcrumbItem key={item.label} {...sharedItemProps} flexShrink={index === 0 ? 0 : undefined}>
                <BreadcrumbLink
                  href={item.href}
                  {...sharedLinkProps}
                  noOfLines={index === 0 ? undefined : 1}
                  textTransform={index === 0 ? undefined : 'capitalize'}
                  whiteSpace={index === 0 ? 'nowrap' : undefined}
                  wordBreak={index === 0 ? undefined : 'break-all'}
                >
                  {item.label}
                </BreadcrumbLink>
              </BreadcrumbItem>
            );
          })}
        </Breadcrumb>
      </ContentContainer>
    </Box>
  );
}
